/* global propel */

const alerts = document.querySelectorAll('.block-alert-popup');
let externalLinks;
const cookieName = 'alert-popup';
let currentUrl;

const leavingPopups = document.querySelectorAll(
	'.main-footer__popup-leaving > .block-alert-popup'
);

const setCookie = (name, value, days) => {
	const date = new Date();
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
	const expires = 'expires=' + date.toUTCString();
	document.cookie =
		name + '=' + JSON.stringify(value) + ';' + expires + ';path=/';
};

const getCookie = (name) => {
	const cookieValue = document.cookie.match(
		'(^|;)\\s*' + name + '\\s*=\\s*([^;]+)'
	);
	return cookieValue ? decodeURIComponent(cookieValue.pop()) : null;
};

const alertState = JSON.parse(getCookie(cookieName)) || {};

const setStorage = () => {
	setCookie(cookieName, alertState, 7); // Set cookie with a week expiration
};

const keydown = (e) => {
	if ('Escape' === e.key) {
		const firstOpenAlert = document.querySelector(
			'.block-alert-popup:not(.block-alert-popup--hidden)'
		);

		if (!firstOpenAlert || !firstOpenAlert.id) {
			document.addEventListener('keydown', keydown);
			return;
		}

		firstOpenAlert.classList.add('block-alert-popup--hidden');
		alertState[firstOpenAlert.id] = { viewed: true };
		setStorage();
	}
};

const clickExternalLink = (e) => {
	if (!e.currentTarget.href) {
		return;
	}

	if (!leavingPopups.length) {
		return;
	}

	let popupOpened = false;

	leavingPopups.forEach((leavingPopup) => {
		if (popupOpened) {
			return;
		}

		let includedUrls = [];
		let excludedUrls = [propel.siteUrl];

		if (leavingPopup.hasAttribute('data-include-urls')) {
			includedUrls = JSON.parse(
				leavingPopup.getAttribute('data-include-urls')
			);
		}

		if (leavingPopup.hasAttribute('data-exclude-urls')) {
			excludedUrls = JSON.parse(
				leavingPopup.getAttribute('data-exclude-urls')
			);

			excludedUrls.push(propel.siteUrl);
		}

		if (
			includedUrls.length > 0 &&
			!includedUrls.some((url) => {
				return e.currentTarget.href.includes(url);
			})
		) {
			return;
		}

		if (
			excludedUrls.length > 0 &&
			excludedUrls.some((url) => {
				return e.currentTarget.href.includes(url);
			})
		) {
			return;
		}

		e.preventDefault();

		currentUrl = e.currentTarget.href;
		leavingPopup.classList.remove('block-alert-popup--hidden');

		const confirmButtons = leavingPopup.querySelectorAll('a[href="#"]');

		if (confirmButtons.length > 0) {
			confirmButtons.forEach((confirmButton) => {
				confirmButton.addEventListener('click', confirmExternalLink);
			});
		}

		popupOpened = true;
	});
};

const confirmExternalLink = (e) => {
	if (!currentUrl) {
		return;
	}

	e.preventDefault();

	const openPopups = document.querySelectorAll(
		'.main-footer__popup-leaving > .block-alert-popup:not(.block-alert-popup--hidden)'
	);

	if (openPopups.length) {
		openPopups.forEach((openPopup) => {
			openPopup.classList.add('block-alert-popup--hidden');
		});
	}

	window.open(currentUrl, '_blank');

	currentUrl = '';
};

if (alerts.length > 0) {
	document.addEventListener('keydown', keydown);

	alerts.forEach((alert) => {
		if (!alert.id) {
			return;
		}

		const alertID = alert.id;
		const alertCloseButtons = alert.querySelectorAll(
			'.block-alert-popup__close-button'
		);

		//Close alert item and set cookie
		if (alertCloseButtons.length > 0) {
			alertCloseButtons.forEach((alertCloseButton) => {
				alertCloseButton.addEventListener('click', function (e) {
					e.preventDefault();
					alert.classList.add('block-alert-popup--hidden');
					alertState[alertID] = { viewed: true };
					setStorage();
				});
			});
		}

		if (
			alert.parentElement &&
			alert.parentElement.classList.contains('main-footer__popup-leaving')
		) {
			if (!externalLinks) {
				externalLinks = document.querySelectorAll([
					'a[href]:not(.block-navigation-quick-links__language-link)',
				]);

				if (externalLinks.length > 0) {
					externalLinks.forEach((externalLink) => {
						externalLink.addEventListener(
							'click',
							clickExternalLink
						);
					});
				}
			}

			return;
		}

		//No cookie, set all to not viewed
		if (!alertState[alertID]) {
			alertState[alertID] = { viewed: false };
			alert.classList.remove('block-alert-popup--hidden');
			setStorage();

			return;
		}

		if (alertState[alertID].viewed) {
			alert.classList.add('block-alert-popup--hidden');
		} else {
			alert.classList.remove('block-alert-popup--hidden');
		}
	});
}
